import React from 'react';
import { XCircle, ArrowLeft, Zap } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Layout/Header';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header />

      <div className="flex-1 flex items-center justify-center p-6">
        <div className="bg-white rounded-3xl shadow-xl p-10 max-w-md w-full text-center">
          <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-11 h-11 text-gray-400" />
          </div>

          <h1 className="text-2xl font-bold text-gray-900 mb-3">Payment Canceled</h1>
          <p className="text-gray-500 mb-8">
            No worries — you haven't been charged. You can upgrade whenever you're ready.
          </p>

          <div className="space-y-3">
            <button
              onClick={() => navigate('/pricing')}
              className="w-full h-12 bg-gradient-to-r from-amber-400 to-orange-500 hover:from-amber-500 hover:to-orange-600 text-white font-bold rounded-xl flex items-center justify-center gap-2 transition-all shadow-md shadow-orange-200"
            >
              <Zap className="w-4 h-4" /> View Plans
            </button>
            <button
              onClick={() => navigate(-1)}
              className="w-full h-12 border border-gray-200 rounded-xl font-semibold text-gray-700 hover:bg-gray-50 transition-colors flex items-center justify-center gap-2"
            >
              <ArrowLeft className="w-4 h-4" /> Go Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
